module.exports = __webpack_public_path__ + "img/triangle-middleText_hover.75bcf6ea.png";